import { render, staticRenderFns } from "./CustomerImportIlustraSuccess.vue?vue&type=template&id=2f171d23&"
import script from "./CustomerImportIlustraSuccess.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportIlustraSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports